import { useBusEmitterListener } from "../bridge";
import { getWellKnownServiceMatch } from "../rich-text/links/cards/well-known/providers";
import { useDocumentStore } from "../store/document";
import { useMetadataStore } from "../store/smartLink";

const activeLinksChangedEvent = Symbol("bridge:activeLinksChanged");
const editLinkTriggeredEvent = Symbol("bridge:editLinkTriggered");

const iframeWidgetAddedEvent = Symbol("bridge:iframeWidgetAdded");
const iframeWidgetEditedEvent = Symbol("bridge:iframeWidgetEdited");
const iframeWidgetDeletedEvent = Symbol("bridge:iframeWidgetDeleted");

export const {
  emitter: activeLinksChanged,
  listener: onActiveLinksChanged,
} = useBusEmitterListener(activeLinksChangedEvent);

export const {
  emitter: editLinkTriggered,
  listener: onEditLinkTriggered,
} = useBusEmitterListener<string>(editLinkTriggeredEvent);

export const {
  emitter: iframeWidgetAdded,
  listener: onIframeWidgetAdded,
} = useBusEmitterListener<string>(iframeWidgetAddedEvent);

export const {
  emitter: iframeWidgetEdited,
  listener: onIframeWidgetEdited,
} = useBusEmitterListener<string>(iframeWidgetEditedEvent);

export const {
  emitter: iframeWidgetDeleted,
  listener: onIframeWidgetDeleted,
} = useBusEmitterListener<string>(iframeWidgetDeletedEvent);

export async function requestUrl() {
  // await askUrl();

  // const link = selectionSmartLink.value;
  // if (!link) return;

  // const smartLink = getAll().items.find(d => d.id === link.id);
  // if (!smartLink) return;
  // // eslint-disable-next-line no-alert
  // const url = window.prompt("Set URL", smartLink.url);
  // if (url) {
  //   const metadata = await getUrlMetadata(url);
  //   await deactivate(smartLink.id);
  //   await setSmartLinkUrl(smartLink.id, url, metadata.embedUrl, metadata.meta.title, metadata.thumbnailImage?.data);
  //   await activate(smartLink.id);
  // } else if (url === "") {
  //   await deactivate(smartLink.id);
  //   await setSmartLinkUrl(smartLink.id, url, "", "", undefined);
  // }
}

export async function fetchMetadata(url: string) {
  const store = useMetadataStore();
  return store.tryFetchOrGetMetadataAsString(url);
}

export async function getWellKnownServiceInfo(url: string) {
  const match = getWellKnownServiceMatch(url);
  let info = null;
  switch (match?.name) {
    case "axure":
      info = { name: match.name, title: match.shortcut };
      break;
    case "jira":
      info = { name: match.name, title: match.key };
      break;
    case "linear":
      info = { name: match.name, title: match.key };
      break;
  }
  return JSON.stringify(info);
}

export async function getUserMetadataInfo(userId: string) {
  const { shortcut } = useDocumentStore();
  const store = useMetadataStore();
  const user = await store.tryFetchOrGetUserMetadata(userId, shortcut);
  const result = user ? { name: user.UserEmail, isCurrent: user.IsMe } : null;
  return JSON.stringify(result);
}
